<div class="modal" data-iframe-size>
  <div class="header">
    <h3 class="title">
      {{ 'i18n.dialog.imageQuality.title' | translate }}
    </h3>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon svgIcon="close"
              class="close-x"></mat-icon>
    </button>
  </div>
  <div class="content" >
    <img class="rating-image" [src]="imageUrl"
      [alt]="'i18n.control.imageQuality.title.' + imageQualityRating | translate">
    <div class="image-quality-rating-row" [class.bad-indicator]="imageQualityRating !== 'good'">
      <div class="image-quality-indicator-container">
        <div class="image-quality-rating good">
          <mat-icon class="rating-smiley" [svgIcon]="'good'">
          </mat-icon>
        <div class="image-quality-rating-title">
          {{ 'i18n.dialog.imageQuality.indicator.good' | translate }}
        </div>
      </div>
      <p class="image-quality-rating-subtitle">
        {{ 'i18n.dialog.imageQuality.subtitle.good' | translate }}
      </p>
    </div>
    @if (imageQualityRating !== 'good') {
      <div class="image-quality-indicator-container">
        <div class="image-quality-rating" [class]="imageQualityRating">
          <mat-icon class="rating-smiley" [svgIcon]="imageQualityRating">
          </mat-icon>
          <div class="image-quality-rating-title">
            {{ 'i18n.dialog.imageQuality.indicator.' + imageQualityRating | translate }}
          </div>
        </div>
        <p class="image-quality-rating-subtitle">
          {{ 'i18n.dialog.imageQuality.subtitle.' + imageQualityRating | translate }}
        </p>
      </div>
    }
  </div>
  <div class="image-quality-content">
    {{ 'i18n.dialog.imageQuality.content.' + imageQualityRating | translate }}
  </div>
</div>
